import { MoneyBack } from 'fitify-ui-onboarding/src/components/Paywall/MoneyBack/MoneyBack'
import { Segment } from 'fitify-ui-onboarding/src/components/Paywall/Segment/Segment'
import { useTranslation } from 'next-i18next/pages'

import { getImageProps } from 'utils/images'

export const MoneyBackGuarantee = () => {
  const { t } = useTranslation()
  return (
    <Segment title={t('paywall_guarantee_title')}>
      <MoneyBack
        cardsImages={[
          getImageProps('shared', 'subscription', 'logoVisa'),
          getImageProps('shared', 'subscription', 'logoAmex'),
          getImageProps('shared', 'subscription', 'logoDiscover'),
          getImageProps('shared', 'subscription', 'logoMastercard'),
          getImageProps('shared', 'subscription', 'logoPayPal'),
          getImageProps('shared', 'subscription', 'logoGooglePay'),
          getImageProps('shared', 'subscription', 'logoApplePay'),
        ]}
        cardsTitle={t('paywall_guaranteed_safe_checkout')}
        moneyBackDescription={t('paywall_guarantee_message')}
        moneyBackImage={getImageProps('shared', 'subscription', 'moneyBack')}
      />
    </Segment>
  )
}
